import React from "react";
import "./index.scss";
import Translation from "../translations";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa";
import { AiOutlineYoutube } from "react-icons/ai";

export default function Footer() {
  return (
    <div className="footer-account">
      <div className="footer-content-account">
        <p className="account-p-copyright">
          <Translation label={"_copyright"} />
        </p>

        <div className="div-policy-icons">
          <div className="div-privacy-policy">
            <a
              className="account-a-privacy-policy"
              href="https://flashpetrol.am/docs/privacy_policy_en.html"
              target="_blank"
              rel="noreferrer"
            >
              <p>
                <Translation label={"_privacyPolicy"} />
              </p>
            </a>
          </div>

          <div className="social-icons">
            <a
              className="color-white"
              href="https://www.facebook.com/flash.petrol.armenia"
              target="_blank"
              rel="noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              className="color-white"
              href="https://www.instagram.com/flash.petrol"
              target="_blank"
              rel="noreferrer"
            >
              <FaInstagram />
            </a>
            <a
              className="color-white"
              href="https://www.youtube.com/@flashpetrol1324"
              target="_blank"
              rel="noreferrer"
            >
              <AiOutlineYoutube />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
